import { Zap, Eye, Snowflake, ShieldCheck } from "lucide-react";
import { IMG } from "@/lib/site";
import Chapter from "@/components/cinema/Chapter";
import { Reveal, LineReveal } from "@/components/cinema/Reveal";

const apart = [
  { icon: Zap, num: "01", t: "We move when others wait.", d: "Our line is answered live, 24/7. Crews dispatch fast across Toronto and the GTA, because the first hour after a loss is the one that matters most." },
  { icon: Eye, num: "02", t: "We see what others miss.", d: "Every item documented. Every box labeled. Every claim-ready inventory built to hold up to adjuster scrutiny, so nothing gets lost in the chaos." },
  { icon: Snowflake, num: "03", t: "We're built for Canadian weather.", d: "Winter pipe bursts, ice storms, spring floods, summer sewer backups — we're staffed and equipped year-round for whatever the GTA throws at a property." },
  { icon: ShieldCheck, num: "04", t: "We treat your home like ours.", d: "Heirlooms, electronics, art, paperwork, handled with the discipline of a contents specialist, not a moving truck. Calm, considered, careful." },
];

export default function ApartChapter() {
  return (
    <Chapter img={IMG.iceStorm} overlay="dark" testId="what-sets-apart">
      <div className="grid md:grid-cols-12 gap-10 mb-16 md:mb-20">
        <div className="md:col-span-6">
          <Reveal y={16}><div className="live-pill mb-6"><span className="dot"></span> What sets us apart</div></Reveal>
          <LineReveal
            className="display-chunky text-5xl md:text-7xl leading-[0.92]"
            lines={["Anyone can show up.", <span className="text-[hsl(var(--gaza-crimson-bright))]">We show up first.</span>]}
          />
        </div>
        <Reveal delay={0.35} className="md:col-span-6 md:pt-8 text-white/75 text-lg leading-relaxed">
          Emergency restoration isn't just about cleaning up. It's about reading the room in the first ten minutes, protecting the things that can't be replaced, and giving homeowners, contractors and insurers a single team they can count on from call one to closeout.
        </Reveal>
      </div>

      <div className="border-t border-white/15">
        {apart.map((a, i) => (
          <Reveal key={a.num} delay={i * 0.12} y={24}>
            <div className="group grid md:grid-cols-12 gap-6 md:gap-10 items-start py-8 md:py-10 border-b border-white/15 transition-colors hover:bg-white/[0.04] md:px-4 -mx-0 md:-mx-4" data-testid={`apart-${a.num}`}>
              <div className="md:col-span-1 mega-num text-4xl md:text-5xl text-white/25 group-hover:text-[hsl(var(--gaza-crimson-bright))] transition-colors">{a.num}</div>
              <div className="md:col-span-5 flex items-start gap-4">
                <a.icon className="w-6 h-6 mt-1 shrink-0 text-[hsl(var(--gaza-crimson-bright))]" strokeWidth={2} />
                <h3 className="display-chunky text-2xl md:text-3xl xl:text-4xl text-white leading-tight">{a.t}</h3>
              </div>
              <p className="md:col-span-6 text-white/75 leading-relaxed text-base md:text-lg">{a.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Chapter>
  );
}
